import { render } from "./SelectOrder.vue?vue&type=template&id=552282a2&scoped=true"
import script from "./SelectOrder.vue?vue&type=script&lang=js"
export * from "./SelectOrder.vue?vue&type=script&lang=js"

import "./SelectOrder.vue?vue&type=style&index=0&id=552282a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552282a2"]])

export default __exports__